export const styles = ({ components, mixins }) => ({
  buttonRoot: {
    outline: 'none !important',
    fontSize: 'unset',
  },
  refreshButtonDisabled: {
    opacity: 0.6,
  },
  disabledIcon: {
    opacity: 0.75,
  },
  refreshDivButton: {
    color: mixins.navigation.iconColor,
    opacity: mixins.navigation.rowOpacity,
    justifyContent: 'unset',
    whiteSpace: 'nowrap',
    display: 'flex',
    flexDirection: 'row',
    textTransform: 'none',
    alignItems: 'center',
    textAlign: 'center',
    outline: 'none',
    padding: `${mixins.navigation.iconVerticalSpacing}px 32px ${mixins.navigation.iconVerticalSpacing}px 16px`,
    width: mixins.navigation.barWidth + mixins.accountDrawer.width,
    '&:hover': {
      opacity: 1,
      color: `${mixins.navigation.iconHoverColor} !important`,
      background: `${mixins.navigation.hoverBackground} !important`,
      cursor: 'pointer',
    },
    transition: mixins.navigation.selectedIconAnimation,
  },
  navText: {
    color: mixins.navigation.textColor,
  },
  disabledRefreshDivButton: {
    pointerEvents: 'none',
  },
});
